<template>
  <div>
    <basic-container>
      <avue-data-icons :option="headerData"></avue-data-icons>
    </basic-container>
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="first">
          <span slot="label"
            >未处理工单池(<span style="color: red">{{ page1.total }}</span
            >)</span
          >
          <el-form
            ref="searchForm"
            :model="query"
            label-width="100px"
            margin-top="0"
            :rules="rules"
          >
            <el-col :span="5">
              <el-form-item label="工单编号" prop="wordId">
                <el-input v-model="query1.wordId" placeholder="工单编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="小区名称" prop="areaId">
                <el-select
                  v-model="query1.areaId"
                  placeholder="请选择小区"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="item in allPropertyList"
                    :key="item.id"
                    :label="item.objectFullName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <el-button
                  type="primary"
                  native-type="submit"
                  icon="el-icon-search"
                  @click.prevent="onLoad1"
                  >搜索
                </el-button>
                <el-button type="white" @click="searchReset1" icon="el-icon-delete">清空</el-button>
              </el-form-item>
            </el-col>
          </el-form>
          <avue-crud
            :option="repairOption"
            :table-loading="loading1"
            :data="data1"
            :page.sync="page1"
            :permission="permissionList"
            :before-open="beforeOpen"
            v-model="form1"
            ref="crud"
            @row-save="rowSave"
            @row-del="rowDel"
            @search-change="searchChange1"
            @search-reset="searchReset1"
            @selection-change="selectionChange"
            @current-change="currentChange1"
            @size-change="sizeChange1"
            @on-load="onLoad1"
            @refresh-change="onLoad1"
            @current-row-change="handleRowClick"
            @row-dblclick="handleRowDBLClick"
          >
            <template slot="menuLeft">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="openAddDialog"
                v-if="permission.repairinfo_register"
              >
                登 记
              </el-button>
            </template>
            <template slot-scope="scope" slot="menu">
              <el-button
                type="text"
                size="small"
                icon="el-icon-finished"
                @click="get(scope.row.id)"
                v-if="permission.repairinfo_get"
                >领 取
              </el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-s-promotion"
                @click="openDesignateDialog(scope.row.id)"
                v-if="permission.repairinfo_designate"
                >指 派
              </el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-view"
                @click="openRepairLogDialog(scope.row.id, scope.row.wordId)"
                >历 程
              </el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-download"
                v-if="permission.repairinfo_print"
                @click="showPrint(scope.row.id)"
                >打 印
              </el-button>
            </template>

            <template slot="isExigency" slot-scope="scope">
              <el-tag v-show="scope.row.isExigency == 1">紧急</el-tag>
              <el-tag type="danger" v-show="scope.row.isExigency == 2">特急</el-tag>
              <el-tag type="info" v-show="scope.row.isExigency == 0">一般</el-tag>
            </template>
            <template slot="complaintParentStatus" slot-scope="scope">
              <el-tag type="danger" v-show="scope.row.complaintParentStatus == 1">登记</el-tag>
              <el-tag type="danger" v-show="scope.row.complaintParentStatus == 2">受理</el-tag>
              <el-tag type="success" v-show="scope.row.complaintParentStatus == 3">处理</el-tag>
              <el-tag type="success" v-show="scope.row.complaintParentStatus == 4">核验</el-tag>
              <el-tag type="warning" v-show="scope.row.complaintParentStatus == 5">完成</el-tag>
            </template>
            <template slot="complaintSubStatus" slot-scope="scope">
              <el-tag>{{ showResult(scope.row) }}</el-tag>
            </template>
          </avue-crud>
        </el-tab-pane>

        <el-tab-pane name="second">
          <span slot="label"
            >我的待办(<span style="color: red">{{ page2.total }}</span
            >)</span
          >
          <avue-crud
            :option="repairOption"
            :table-loading="loading2"
            :data="data2"
            :page.sync="page2"
            :permission="permissionList"
            :before-open="beforeOpen"
            v-model="form2"
            ref="crud"
            @row-save="rowSave"
            @row-del="rowDel"
            @search-change="searchChange2"
            @search-reset="searchReset2"
            @selection-change="selectionChange"
            @current-change="currentChange2"
            @size-change="sizeChange2"
            @on-load="onLoad2"
            @refresh-change="onLoad2"
            @current-row-change="handleRowClick"
            @row-dblclick="handleRowDBLClick"
            :show-overflow-tooltip="true"
          >
            <template slot="menuLeft">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="openAddDialog"
                v-if="permission.repairinfo_register"
              >
                登 记
              </el-button>
            </template>
            <template slot-scope="scope" slot="menu">
              <el-button
                type="text"
                size="small"
                icon="el-icon-finished"
                @click="openDrawer(scope.row.id)"
                v-if="permission.repairinfo_manage"
                >办 理
              </el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-s-promotion"
                @click="openRedeployDialog(scope.row.id)"
                v-if="permission.repairinfo_track"
                >转 单
              </el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-view"
                @click="openRepairLogDialog(scope.row.id, scope.row.wordId)"
                >历 程
              </el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-s-fold"
                v-if="permission.repairinfo_roll_back"
                @click="openRollBackDialog(scope.row)"
                >回 退
              </el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-download"
                v-if="permission.repairinfo_print"
                @click="showPrint(scope.row.id)"
                >打 印
              </el-button>
            </template>
            <template slot="isExigency" slot-scope="scope">
              <el-tag v-show="scope.row.isExigency == 1">紧急</el-tag>
              <el-tag type="danger" v-show="scope.row.isExigency == 2">特急</el-tag>
              <el-tag type="info" v-show="scope.row.isExigency == 0">一般</el-tag>
            </template>
            <template slot="complaintParentStatus" slot-scope="scope">
              <el-tag type="danger" v-show="scope.row.complaintParentStatus == 1">登记</el-tag>
              <el-tag type="danger" v-show="scope.row.complaintParentStatus == 2">受理</el-tag>
              <el-tag type="success" v-show="scope.row.complaintParentStatus == 3">处理</el-tag>
              <el-tag type="success" v-show="scope.row.complaintParentStatus == 4">核验</el-tag>
              <el-tag type="warning" v-show="scope.row.complaintParentStatus == 5">完成</el-tag>
            </template>
            <template slot="complaintSubStatus" slot-scope="scope">
              <el-tag>{{ showResult(scope.row) }}</el-tag>
            </template>
          </avue-crud>
        </el-tab-pane>

        <el-tab-pane label="已完成" name="third">
          <avue-crud
            :option="repairOption"
            :table-loading="loading3"
            :data="data3"
            :page.sync="page3"
            :permission="permissionList"
            :before-open="beforeOpen"
            v-model="form3"
            ref="crud"
            @row-save="rowSave"
            @row-del="rowDel"
            @search-change="searchChange3"
            @search-reset="searchReset3"
            @selection-change="selectionChange"
            @current-change="currentChange3"
            @size-change="sizeChange3"
            @on-load="onLoad3"
            @refresh-change="onLoad3"
            @current-row-change="handleRowClick"
            @row-dblclick="handleRowDBLClick"
          >
            <template slot-scope="scope" slot="menu">
              <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="openDrawer(scope.row.id)"
                >查 看
              </el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-view"
                @click="openRepairLogDialog(scope.row.id, scope.row.wordId)"
                >历 程
              </el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-download"
                v-if="permission.repairinfo_print"
                @click="showPrint(scope.row.id)"
                >打 印
              </el-button>
            </template>
            <template slot="isExigency" slot-scope="scope">
              <el-tag v-show="scope.row.isExigency == 1">紧急</el-tag>
              <el-tag type="danger" v-show="scope.row.isExigency == 2">特急</el-tag>
              <el-tag type="info" v-show="scope.row.isExigency == 0">一般</el-tag>
            </template>
            <template slot="complaintParentStatus" slot-scope="scope">
              <el-tag type="danger" v-show="scope.row.complaintParentStatus == 1">登记</el-tag>
              <el-tag type="danger" v-show="scope.row.complaintParentStatus == 2">受理</el-tag>
              <el-tag type="success" v-show="scope.row.complaintParentStatus == 3">处理</el-tag>
              <el-tag type="success" v-show="scope.row.complaintParentStatus == 4">核验</el-tag>
              <el-tag type="warning" v-show="scope.row.complaintParentStatus == 5">完成</el-tag>
            </template>
            <template slot="complaintSubStatus" slot-scope="scope">
              <el-tag>{{ showResult(scope.row) }}</el-tag>
            </template>
          </avue-crud>
        </el-tab-pane>
      </el-tabs>

      <!--登记弹窗-->
      <el-dialog
        :visible.sync="repairAddShowDialogFlag"
        :modal-append-to-body="false"
        @closed="quitRepairAddDialog"
        :append-to-body="true"
      >
        <div class="el-property-dialog-div">
          <avue-form
            ref="repairAddFormRef"
            v-model="repairAddFrom"
            :option="repairAddOption"
            @submit="repairAddSubmit"
            :upload-before="uploadBefore"
          >
            <template slot="repairDesc" slot-scope="scope">
              <el-input
                v-model="repairAddFrom.repairDesc"
                placeholder="请输入反映内容"
                maxlength="100"
                show-word-limit
              ></el-input>
            </template>
            <template slot="address" slot-scope="scope">
              <el-input
                placeholder="请输入详细地址"
                v-model="repairAddFrom.address"
                :disabled="propertyFlag"
                class="input-with-select"
                :readonly="readOnly"
              >
                <el-button
                  :disabled="propertyFlag"
                  slot="append"
                  icon="el-icon-search"
                  @click="showRoomSelect = true"
                  >选择房产</el-button
                >
                <el-button
                  :disabled="propertyFlag"
                  slot="append"
                  icon="el-icon-delete"
                  @click="cleanProperty"
                  >重新选择</el-button
                >
              </el-input>
            </template>
            <template slot="areaId" slot-scope="scope">
              <el-select
                v-model="repairAddFrom.areaId"
                placeholder="请选择小区"
                style="width: 100%"
                clearable
                @change="changeSelectType"
              >
                <el-option
                  v-for="item in allPowerPropertyList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </template>
            <template slot="repairTypeId" slot-scope="scope">
              <el-select
                v-model="repairAddFrom.repairTypeId"
                placeholder="请选择反应类型"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in allPowerTypeList"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope" slot="menuForm">
              <el-button plain type="primary" icon="el-icon-plus" @click="repairAddCommit"
                >提交
              </el-button>
            </template>
            <el-button
              type="text"
              size="small"
              icon="el-icon-download"
              v-if="permission.repairinfo_print"
              @click="showPrint(scope.row.id)"
              >打 印
            </el-button>
          </avue-form>
        </div>
      </el-dialog>
      <!--办理弹出框-->
      <el-drawer
        :visible.sync="drawerFlag"
        :modal-append-to-body="false"
        :before-close="handleDrawerClose"
        :append-to-body="true"
        id="manageDrawer"
        size="70%"
      >
        <avue-form
          v-if="drawerFlag"
          ref="manageOptionFormRef"
          v-model="manageOptionForm"
          :option="option"
          :upload-preview="uploadPreview"
          :upload-before="uploadBefore"
        >
          <template slot="repairDesc" slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="manageOptionForm.repairDesc"
              placement="top-start"
              :disabled="!areaFlag"
            >
              <el-input
                v-model="manageOptionForm.repairDesc"
                :disabled="areaFlag"
                maxlength="100"
                show-word-limit
              >
              </el-input>
            </el-tooltip>
          </template>
          <template slot="address" slot-scope="scope">
            <el-input
              placeholder="请输入详细地址"
              v-model="manageOptionForm.address"
              :disabled="propertyFlag"
              class="input-with-select"
              :readonly="readOnly"
            >
              <el-button
                :disabled="propertyFlag"
                slot="append"
                icon="el-icon-search"
                @click="showRoomSelect = true"
                >选择房产</el-button
              >
              <el-button
                :disabled="propertyFlag"
                slot="append"
                icon="el-icon-delete"
                @click="cleanProperty"
                >重新选择</el-button
              >
            </el-input>
          </template>
          <template slot="materials" slot-scope="scope">
            <div>
              <avue-crud ref="crud1" :data="priceData" :option="repairPriceOption">
                <template slot="menuLeft">
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="openRepairCostPriceDialog"
                    :disabled="processDeptFlag"
                    >选择收费项
                  </el-button>
                </template>
              </avue-crud>
              <el-row>
                <el-col span="4">
                  <el-form-item label="总金额">
                    <el-input disabled="true" v-model="totalAmount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="4">
                  <el-form-item label="支付方式">
                    <el-select
                      v-model="manageOptionForm.payType"
                      placeholder="请选择"
                      style="width: 100%"
                      clearable
                      :disabled="processDeptFlag"
                    >
                      <el-option label="微信" :value="2"></el-option>
                      <el-option label="支付宝" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col span="1"></el-col>
                <el-col span="4">
                  <el-button
                    type="primary"
                    STYLE="display: none"
                    :disabled="processDeptFlag"
                    @click="genearateQrCode"
                    >收 款</el-button
                  >
                </el-col>
              </el-row>
            </div>
          </template>
          <template slot="areaId" slot-scope="scope">
            <el-select
              v-model="manageOptionForm.areaId"
              placeholder="请选择小区"
              style="width: 100%"
              clearable
              :disabled="areaFlag"
              @change="changeSelectType"
            >
              <el-option
                v-for="item in allPropertyList"
                :key="item.id"
                :label="item.objectFullName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
          <template slot="repairTypeId" slot-scope="scope">
            <el-select
              v-model="manageOptionForm.repairTypeId"
              placeholder="请选择反应类型"
              style="width: 100%"
              clearable
              :disabled="repairTypeFlag"
              v-if="!repairTypeFlag"
            >
              <el-option
                v-for="item in allPowerTypeList"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="manageOptionForm.repairTypeId"
              placeholder="请选择反应类型"
              style="width: 100%"
              clearable
              :disabled="repairTypeFlag"
              v-if="repairTypeFlag"
            >
              <el-option
                v-for="item in allTypeList"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
          <template slot="processDeptId" slot-scope="scope">
            <el-select
              v-model="manageOptionForm.processDeptId"
              placeholder="处理部门"
              style="width: 100%"
              :disabled="processDeptFlag"
            >
              <el-option
                v-for="(item, index) in allDeptList"
                :key="index"
                :label="item.title"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
          <template slot="visitType" slot-scope="scope">
            <el-select
              v-model="manageOptionForm.visitType"
              placeholder="回访形式"
              style="width: 100%"
              :disabled="visitTypeFlag"
            >
              <el-option
                v-for="(item, index) in allVisitTypeList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button
              type="primary"
              icon="el-icon-plus"
              :loading="manageSubmit"
              @click="manageSave"
              v-show="manageOptionForm.complaintParentStatus != 5 && activeName == 'second'"
              >保存
            </el-button>
            <el-button
              plain
              type="primary"
              icon="el-icon-check"
              :loading="manageSubmit"
              @click="manageCommit"
              v-show="manageOptionForm.complaintParentStatus != 5 && activeName == 'second'"
              >提交
            </el-button>
            <el-button
              plain
              type="primary"
              icon="el-icon-finished"
              v-if="permission.repairinfo_get && activeName == 'first'"
              @click="get"
              >领 取
            </el-button>
            <el-button
              plain
              type="primary"
              icon="el-icon-s-promotion"
              @click="openDesignateDialog"
              v-if="permission.repairinfo_designate && activeName == 'first'"
              >指 派
            </el-button>
            <el-button
              plain
              type="primary"
              icon="el-icon-s-promotion"
              @click="openRedeployDialog(1)"
              v-if="
                permission.repairinfo_track &&
                manageOptionForm.complaintParentStatus != 5 &&
                activeName == 'second'
              "
              >转 单
            </el-button>
            <el-button
              plain
              type="primary"
              icon="el-icon-s-fold"
              v-if="permission.repairinfo_roll_back && activeName == 'second'"
              @click="openRollBackDialog(1)"
              >回 退
            </el-button>
            <el-button plain type="primary" icon="el-icon-view" @click="openRepairLogDialog(1)"
              >历 程
            </el-button>
            <el-button
              plain
              type="primary"
              v-if="permission.repairinfo_print"
              icon="el-icon-download"
              @click="showPrint(manageOptionForm.id)"
              >打 印
            </el-button>
            <el-button
              plain
              type="danger"
              icon="el-icon-folder-delete"
              @click="repairClose"
              v-if="permission.repairinfo_close && activeName == 'second'"
              >关 闭
            </el-button>
          </template>
        </avue-form>
      </el-drawer>
      <!--指派弹窗-->
      <el-dialog
        title="指派"
        :visible.sync="designateShowDialogFlag"
        :modal-append-to-body="false"
        width="50%"
        @close="closeDesignateDialog"
        append-to-body
      >
        <el-form
          :model="designateFrom"
          ref="designateFromRef"
          label-width="100px"
          margin-top="0"
          :rules="rules"
        >
          <el-row>
            <el-col span="12">
              <el-form-item label="指派部门" prop="operatorDept">
                <el-select
                  v-model="designateFrom.operatorDept"
                  placeholder="指派部门"
                  style="width: 100%"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="(item, index) in allDeptList"
                    :key="index"
                    :label="item.title"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="指派责任人" prop="operatorId">
                <el-select
                  v-model="designateFrom.operatorId"
                  placeholder="不选择责任人工单进入该部门工单池中"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in allUserList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col align="center">
              <el-button type="primary" @click="designate(1)">确定</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!--转单弹窗-->
      <el-dialog
        title="转单"
        :visible.sync="redeployShowDialogFlag"
        :modal-append-to-body="false"
        width="50%"
        @close="closeDesignateDialog"
        append-to-body
      >
        <el-form
          :model="designateFrom"
          ref="trackFromRef"
          label-width="100px"
          margin-top="0"
          :rules="rules"
        >
          <el-row>
            <el-col span="12">
              <el-form-item label="转单部门" prop="operatorDept">
                <el-select
                  v-model="designateFrom.operatorDept"
                  placeholder="转单部门"
                  style="width: 100%"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="(item, index) in allDeptList"
                    :key="index"
                    :label="item.title"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="转单责任人" prop="operatorId">
                <el-select
                  v-model="designateFrom.operatorId"
                  placeholder="不选择责任人工单进入该部门工单池中"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in allUserList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="24">
              <el-form-item label="转单备注" prop="repairLogRemark">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="designateFrom.repairLogRemark"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col align="center">
              <el-button type="primary" @click="designate(2)">确定</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!--办理提交弹窗-->
      <el-dialog
        title="确认信息"
        :visible.sync="commitFlag"
        :modal-append-to-body="false"
        width="50%"
        @close="closeDesignateDialog"
        append-to-body
      >
        <el-form label-width="100px" margin-top="0" :rules="rules">
          <el-row>
            <el-col span="12">
              <el-form-item label="提交部门" prop="manageOperatorDept">
                <el-select
                  v-model="manageOperatorDept"
                  placeholder="提交部门"
                  style="width: 100%"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="item in allDeptList"
                    :key="item.value"
                    :label="item.title"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="提交责任人" prop="operator">
                <el-select
                  v-model="operatorId"
                  placeholder="不选择责任人工单进入该部门工单池中"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in allUserList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col align="center">
              <el-button :loading="manageSubmit" type="primary" @click="commit">确定</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!--新增提交弹窗-->
      <el-dialog
        title="确认信息"
        :visible.sync="addCommitFlag"
        :modal-append-to-body="false"
        width="50%"
        @close="closeDesignateDialog"
        append-to-body
      >
        <el-form label-width="100px" margin-top="0" :rules="rules">
          <el-row>
            <el-col span="12">
              <el-form-item label="提交部门" prop="operatorDept">
                <el-select
                  v-model="operatorDept"
                  placeholder="提交部门"
                  style="width: 100%"
                  @change="changeSelectUser"
                >
                  <el-option
                    v-for="(item, index) in allDeptList"
                    :key="index"
                    :label="item.title"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="提交责任人" prop="operator">
                <el-select
                  v-model="operatorId"
                  placeholder="不选择责任人工单进入该部门工单池中"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in allUserList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col align="center">
              <el-button :loading="addSubmit" type="primary" @click="repairAddSubmit"
                >确定</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!--回退弹窗-->
      <el-dialog
        title="回退"
        :visible.sync="repairRollBackFlag"
        :modal-append-to-body="false"
        width="30%"
        @close="closeRollBackDialog"
        append-to-body
      >
        <el-form
          ref="rollBackFromRef"
          :model="repairRollBackFrom"
          label-width="100px"
          margin-top="0"
          :rules="rules"
        >
          <el-row>
            <el-col span="24">
              <el-form-item label="回退环节" prop="complaintParentStatus">
                <el-select
                  v-model="repairRollBackFrom.complaintParentStatus"
                  placeholder="回退环节"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in allComplaintStatusListCopy"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="回退备注" prop="repairLogRemark">
              <el-input
                type="textarea"
                v-model="repairRollBackFrom.repairLogRemark"
                placeholder="回退备注"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col align="center">
              <el-button type="primary" @click="repairRollBack">确 定</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!--    查看评价弹窗-->
      <review ref="review"></review>
      <!--    流程弹窗-->
      <repairLog ref="repairLog"></repairLog>
      <!--    选择收费项弹窗-->
      <repairCostPrice ref="repairCostPrice" @getData="getDate"></repairCostPrice>
      <!--收款码弹窗-->
      <el-dialog
        title="收款码"
        :visible.sync="payInfo2.showQrCode"
        :close-on-click-modal="false"
        width="30%"
        top="16vh"
        append-to-body
        @close="closeQrCode"
      >
        <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
          {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
        </div>
        <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
          扫码支付后请勿手动关闭弹窗
        </div>
        <div style="text-align: center">
          <div id="qrcodeRepairInfo" ref="qrcode" style="display: inline-block"></div>
          <div>倒计时：{{ payInfo2.countdown }}</div>
        </div>
      </el-dialog>
      <!--选择房产弹窗-->
      <el-dialog
        title="选择房产"
        :visible.sync="showRoomSelect"
        width="30%"
        top="16vh"
        custom-class="room-select-dialog"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
        center
        @close="showRoomSelect = false"
      >
        <RoomSelect @select="selectRoom"></RoomSelect>
        <span slot="footer">
          <el-button @click="showRoomSelect = false">取消</el-button>
          <el-button type="primary" @click="confirmRoom">确定</el-button>
        </span>
      </el-dialog>
    </basic-container>
    <repairPrint
      ref="mychild"
      :allPropertyList="allPropertyList"
      :allComplainTypeList="allTypeList"
      :allComplaintStatusList="allComplaintStatusList"
      :allDeptList="allDeptList"
      :allExigencyList="allExigencyList"
    ></repairPrint>
  </div>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  close,
  get,
  designate,
  update1,
  update2,
  repairRollBack,
  poolPage,
  getCommunity,
} from '@/api/v4ward/repair/repairinfo';
import { mapGetters, mapState } from 'vuex';
import repairOption from './repair-option2';
import repairAddOption from './repair-add-option2';
import repairManageOption from './repair-manage-option2';
import repairVisitOption from './repair-visit-option';
import repairPriceOption from './repair-cost-price';
import { getOptionNode } from '@/api/v4ward/property/baseproperty';
import { getDictionary, selectDept, selectUser } from '@/api/common';
import request from '@/util/request';
import review from '@/views/v4ward/review/reviewshow';
import repairPrint from './print-repairinfo.vue';
import repairLog from '@/views/v4ward/repairlog/repairlogshow';
import repairCostPrice from '@/views/v4ward/repair/repaircostpriceshow';
import { selectAllType, selectType } from '@/api/v4ward/repairtype/repairtype';
import { loadPayStatus, loadZhxx, saveQrCodePay } from '@/api/charge';
import QRCode from 'qrcodejs2';
import RoomSelect from '@/components/room-select2';

let number = /^[1-9]\d*$/;
var NumberText = (rule, value, callback) => {
  if (!number.test(value)) {
    callback(new Error('请正确填写数量'));
  } else {
    callback();
  }
};

export default {
  components: {
    review,
    repairLog,
    repairPrint,
    repairCostPrice,
    RoomSelect,
  },
  data() {
    return {
      addSubmit: false,
      manageSubmit: false,
      dialogVisible: false,
      printShow: false,
      headerData: {
        span: 6,
        data: [
          {
            title: '工单池',
            count: 0,
            icon: 'el-icon-s-custom',
            color: 'rgb(49, 180, 141)',
          },
          {
            title: '受理中',
            count: 0,
            icon: 'el-icon-s-check',
            color: 'rgb(49, 180, 141)',
          },
          {
            title: '处理中',
            count: 0,
            icon: 'el-icon-s-platform',
            color: 'rgb(56, 161, 242)',
          },
          {
            title: '核验中',
            count: 0,
            icon: 'el-icon-s-comment',
            color: 'rgb(117, 56, 199)',
          },
        ],
      },
      zhxx: {
        shortCode: '',
      },
      showRoomSelect: false,
      temp: {},
      title: '',
      activeName: 'first',
      form1: {},
      form2: {},
      form3: {},
      query1: {
        isNull: 0, //初始化加载无经办人工单
      },
      query2: {},
      query3: {
        isNull: 0, //初始化加载无经办人工单
      },
      loading1: true,
      loading2: true,
      loading3: true,
      page1: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      page2: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      page3: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      //主页面
      repairOption: repairOption,
      //新增
      repairAddOption: repairAddOption,
      //处理
      repairManageOption: repairManageOption,
      //回访
      repairVisitOption: repairVisitOption,
      //物料明细
      repairPriceOption: repairPriceOption,

      //窗口显示开关
      repairAddShowDialogFlag: false,
      repairManageShowDialogFlag: false,
      repairCheckShowDialogFlag: false,
      repairConfirmShowDialogFlag: false,
      repairPayShowDialogFlag: false,
      designateShowDialogFlag: false,
      redeployShowDialogFlag: false,
      drawerFlag: false,
      commitFlag: false,
      addCommitFlag: false,
      repairRollBackFlag: false,

      //form表单数据
      repairAddFrom: {},
      repairManageFrom: {},
      repairCheckFrom: {},
      repairConfirmFrom: {},
      repairPayFrom: {},
      designateFrom: {
        operatorId: '',
        operatorDept: '',
      },
      manageOptionForm: {
        materials: [],
      },
      repairRollBackFrom: {},

      allPropertyList: [],
      allPowerPropertyList: [],
      // allComplainTypeList: [],
      allComplaintStatusList: [],
      allComplaintStatusListCopy: [],
      allDeptList: [],
      allUserList: [],

      allExigencyList: [
        { dictKey: 0, dictValue: '一般' },
        { dictKey: 1, dictValue: '紧急' },
        { dictKey: 2, dictValue: '特急' },
      ],
      allVisitTypeList: [],
      allPowerTypeList: [],
      allTypeList: [],

      data1: [],
      data2: [],
      data3: [],
      priceData: [],
      reviewData: [],

      typeFlag: false,
      areaFlag: false,
      repairTypeFlag: false,
      processDeptFlag: false,
      visitTypeFlag: false,
      propertyFlag: false,
      readOnly: false,

      operatorDept: '',
      operatorDeptName: '',
      operatorId: '',
      operatorName: '',
      manageOperatorDept: '',
      manageOption: [],
      rules: {
        complaintParentStatus: [
          {
            required: true,
            message: '请选择回退环节',
            trigger: 'blur',
          },
        ],
        repairLogRemark: [
          {
            required: true,
            message: '请输入备注',
            trigger: 'change',
          },
        ],
        operatorDept: [
          {
            required: true,
            message: '请选择部门',
            trigger: 'change',
          },
        ],
        manageOperatorDept: [
          {
            required: true,
            message: '请选择提交部门',
            trigger: 'change',
          },
        ],
      },
      payInfo2: {
        payDetailList: [],
        showQrCode: false,
        countdown: 120,
        timer: '',
        tradeStatus: 0,
      },
      payInfo: {},
    };
  },
  computed: {
    option() {
      var group = {
        submitBtn: false,
        emptyBtn: false,
        group: this.manageOption,
      };
      return group;
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    ...mapGetters(['permission']),
    permissionList() {
      return {
        registerBtn: this.vaildData(this.permission.repairinfo_register, false), //登记
        getBtn: this.vaildData(this.permission.repairinfo_get, false), //领取
        designateBtn: this.vaildData(this.permission.repairinfo_designate, false), //指派
        manageBtn: this.vaildData(this.permission.repairinfo_manage, false), //办理
        trackBtn: this.vaildData(this.permission.repairinfo_track, false), //转单
        closeBtn: this.vaildData(this.permission.repairinfo_close, false), //关闭
        rollBackBtn: this.vaildData(this.permission.repairinfo_roll_back, false), //回退
        printBtn: this.vaildData(this.permission.repairinfo_print, false), //打印
        addBtn: this.vaildData(this.permission.repairinfo_add, false),
        viewBtn: this.vaildData(this.permission.repairinfo_view, false),
        delBtn: this.vaildData(this.permission.repairinfo_delete, false),
        editBtn: this.vaildData(this.permission.repairinfo_edit, false),
      };
    },
    totalAmount() {
      var a = 0;
      this.priceData.forEach((value, index, array) => {
        a = a + Number(value.num) * Number(value.price);
      });
      return a;
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.getWorkOrderInfo();
    this.initSelectList();
  },
  watch: {
    'manageOptionForm.isVisit': {
      handler(val) {
        this.handlerHide(val);
      },
      immediate: true,
    },
  },
  methods: {
    uploadBefore(file, done, loading) {
      //校验文件大小
      const isLt5M = file.size / 1024 / 1024 > 5;
      if (isLt5M) {
        this.$message.error('文件大小不能超过5MB!');
        loading();
      } else {
        done();
      }
    },
    //查询住户信息
    queryZhxx(params) {
      loadZhxx(params).then(({ data }) => {
        this.zhxx = data[0];
        this.manageOptionForm.address = this.zhxx.roomName;
        this.manageOptionForm.propertyId = this.zhxx.roomId;
        this.repairAddFrom.address = this.zhxx.roomName;
        this.repairAddFrom.propertyId = this.zhxx.roomId;
        this.readOnly = true;
      });
    },
    //选择房产
    selectRoom(item) {
      this.temp.roomId = item.roomId;
    },
    //确认选定房产
    confirmRoom() {
      this.showRoomSelect = false;
      if (this.temp.roomId) {
        this.zhxx.roomId = this.temp.roomId;
        this.queryZhxx({ roomId: this.zhxx.roomId });
      }
    },
    //清空详细地址（房产）
    cleanProperty() {
      this.readOnly = false;
      this.manageOptionForm.address = '';
      this.manageOptionForm.propertyId = '';
      this.repairAddFrom.address = '';
      this.repairAddFrom.propertyId = '';
    },
    //生成二维码
    genearateQrCode() {
      if (this.totalAmount === 0) {
        this.$message.error('总金额为0，请不要点击收款');
        return;
      }
      if (!this.manageOptionForm.payType) {
        this.$message.error('请选择支付方式');
        return;
      }
      let params = this._.merge(
        {
          roomId: this.manageOptionForm.propertyId ? this.manageOptionForm.propertyId : 0,
          roomName: this.manageOptionForm.$areaId ? this.manageOptionForm.$areaId : '',
        },
        {
          workOrderPay: {
            reason: '',
            calAmount: this.totalAmount,
            shouldAmount: this.totalAmount,
            payAmount: this.totalAmount,
          },
        },
        {
          payInfo: {
            billTotalAmount: 0,
            preTotalAmount: 0,
            carTotalAmount: 0,
            temporaryTotalAmount: 0,
            totalShouldAmount: this.totalAmount,
            payDetail: JSON.stringify(this.payInfo2.payDetailList),
            authCode: '',
            payRemark: '',
            payType: this.manageOptionForm.payType,
            paylabel: 'xxx',
            totalAccountpayAmount: 0,
            totalPayAmount: this.totalAmount,
          },
        }
      );
      saveQrCodePay(params, { showLoading: { text: '正在获取二维码' } }).then(({ data }) => {
        this.payInfo2.showQrCode = true;
        this.payInfo.payBillNo = data.payBillNo;
        this.$nextTick(() => {
          new QRCode('qrcodeRepairInfo', {
            width: 250,
            height: 250,
            text: data.codeUrl,
          });
        });
        this.payInfo2.showQrCode = true;
        this.payInfo2.countdown = 120;
        this.payInfo2.timer = setInterval(() => {
          if (this.payInfo2.countdown === 0) {
            clearInterval(this.payInfo2.timer);
            this.payInfo2.showQrCode = false;
            this.$message.info('倒计时结束，二维码弹窗关闭');
          }
          if (this.payInfo2.countdown % 5 === 0) {
            loadPayStatus({ payBillNo: this.payInfo.payBillNo }).then(({ data }) => {
              this.payInfo2.tradeStatus = data.tradeStatus;
              if (data.tradeStatus === 2) {
                this.payInfo2.showQrCode = false;
                this.$message.success('支付成功');
                clearInterval(this.payInfo2.timer);
                //重置数据
                // this.resetAllData();
                // this.submitAllBill();
              }
            });
          }
          this.payInfo2.countdown--;
        }, 1000);
      });
    },
    //关闭二维码
    closeQrCode() {
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = '';
      }, 300);
      clearInterval(this.payInfo2.timer);
    },
    getDate(data) {
      this.priceData = data;
    },
    handlerHide(val) {
      if(this.manageOption.length<3){
        return;
      }
      var visitTime = this.findObject(this.manageOption[2].column, 'visitTime');
      var visitType = this.findObject(this.manageOption[2].column, 'visitType');
      var satisfaction = this.findObject(this.manageOption[2].column, 'satisfaction');
      if (val === 0) {
        visitTime.display = true;
        visitTime.rules = [
          {
            required: true,
            message: '请选择回访时间',
            trigger: 'blur',
          },
        ];
        visitType.display = true;
        visitType.rules = [
          {
            required: true,
            message: '请选择回访形式',
            trigger: 'blur',
          },
        ];
        satisfaction.display = true;
        satisfaction.rules = [
          {
            required: true,
            message: '请选择满意度',
            trigger: 'blur',
          },
        ];
      } else {
        visitTime.display = false;
        visitTime.rules = [];
        visitType.display = false;
        visitType.rules = [];
        satisfaction.display = false;
        satisfaction.rules = [];
      }
    },
    showPrint(id) {
      this.$refs.mychild.showPrint(true, id);
    },
    getWorkOrderInfo() {
      request
        .get('/api/v4ward/welcome/workOrderInfo', Object.assign({}, null, {}))
        .then(({ data }) => {
          for (var i = 0; i < this.headerData.data.length; i++) {
            this.headerData.data[i].count = data.data[i].count;
          }
        });
    },
    /**
     *领取方法
     * @param id
     */
    get(id) {
      if (this.drawerFlag == true) {
        id = this.manageOptionForm.id;
      }
      this.$confirm('确定领取该任务?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return get({
            id: id,
          });
        })
        .then(() => {
          this.drawerFlag = false;
          this.onLoad1();
          this.onLoad2();

          this.$message.success('领取成功!');
        });
    },
    /**
     * 指派或转单
     * @param id
     */
    designate(operaType) {
      if (operaType == 1) {
        this.$refs.designateFromRef.validate((valid) => {
          if (valid) {
            this.designateA(operaType);
          }
        });
      } else if (operaType == 2) {
        this.$refs.trackFromRef.validate((valid) => {
          if (valid) {
            this.designateA(operaType);
          }
        });
      }
    },
    designateA(operaType) {
      this.getOperatorName(this.designateFrom.operatorId);
      this.getOperatorDeptName(this.designateFrom.operatorDept);
      this.designateFrom.operatorName = this.operatorName;
      this.designateFrom.operatorDeptName = this.operatorDeptName;
      this.designateFrom.operaType = operaType;

      designate(this.designateFrom).then(
        () => {
          this.drawerFlag = false;
          this.$message.success('操作成功!');
          this.designateFrom = {};
          if (operaType == 1) {
            this.onLoad1();
            this.designateShowDialogFlag = false;
          } else if (operaType == 2) {
            this.onLoad2();
            this.redeployShowDialogFlag = false;
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    openDesignateDialog(id) {
      if (typeof id === 'string') {
        this.designateFrom.id = id;
      } else {
        this.designateFrom.id = this.manageOptionForm.id;
      }
      this.designateShowDialogFlag = true;
    },

    openRedeployDialog(id) {
      console.log(id);
      if (typeof id === 'string') {
        this.designateFrom.id = id;
      } else {
        this.designateFrom.id = this.manageOptionForm.id;
      }
      console.log(this.designateFrom);
      this.redeployShowDialogFlag = true;
    },
    closeDesignateDialog() {
      this.designateFrom = {
        id:'',
        operatorDept: "",
        operatorId: "",
      };
      this.manageOperatorDept = '';
      this.repairAddFrom.complaintParentStatus = '';
      this.operatorDept = '';
      this.operatorDeptName = '';
      this.operatorId = '';
      this.operatorName = '';
    },
    getOperatorName(value) {
      this.allUserList.forEach((val, index, array) => {
        if (val.id == value) {
          this.operatorName = val.name;
          return;
        }
      });
    },
    getOperatorDeptName(value) {
      this.allDeptList.forEach((val, index, array) => {
        if (val.id == value) {
          this.operatorDeptName = val.title;
          return;
        }
      });
    },
    //////////////////

    handleRowDBLClick(row, event) {
      this.openDrawer(row.id);
    },
    downloadFile(url) {
      try {
        var i = url.lastIndexOf('//11//');
        var name = url.substring(i+6);
        url = url.slice(0,i);
        console.log(name,url);
        let file_url = url;
        let xhr = new XMLHttpRequest();
        xhr.open("get", file_url, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
          if (this.status === 200) {
            const reader = new FileReader()
            reader.readAsDataURL(this.response);
            reader.onload = function (e) {
              let a = document.createElement('a');
              a.setAttribute("download", name);
              a.style.display = "none";
              a.href = e.target.result;
              a.click();
            };
          }
        };
        xhr.send();
      } catch (e) {
        alert('下载异常！');
      }
    },
    uploadPreview(file, column, done) {
      if(column.prop !== 'accessoriesSign'){
        this.downloadFile(file.url);
      }else {
        done();
      }
    },
    //禁用表单文件上传功能;
    hideFormUploadButton(formStatus, tabStatus) {
      this.$nextTick(() => {
        if (tabStatus == 'first' || tabStatus == 'third') {
          let el_list = document.querySelector('#manageDrawer').querySelectorAll('label[for*="accessoriesStr"]');
          if (el_list.length > 0) {
            el_list.forEach((element, index) => {
              element.parentElement.querySelector('button').style.display = 'none';
              let el_list_ = element.parentElement.querySelectorAll('i[class="el-icon-close"]');
              if (el_list_.length > 0) {
                this.hideFormUploadFileCloseButton(el_list_);
              }
            });
          }
        } else {
          let el_list = document.querySelector('#manageDrawer').querySelectorAll('label[for*="accessoriesStr"]');
          if (el_list.length > 0) {
            el_list.forEach((element, index) => {
              if (index < el_list.length - 1) {
                element.parentElement.querySelector('button').style.display = 'none';

                let el_list_ = element.parentElement.querySelectorAll('i[class="el-icon-close"]');
                if (el_list_.length > 0) {
                  this.hideFormUploadFileCloseButton(el_list_);
                }
              }
            });
          }
        }
      });
    },
    //禁用表单文件上传删除功能;
    hideFormUploadFileCloseButton(el_list) {
      el_list.forEach((element, index) => {
        element.style.display = 'none';
      });
    },
    changeUploader(formStatus, tabStatus) {
      this.hideFormUploadButton(formStatus, tabStatus);
      return;
    },
    //办理弹窗相关
    openDrawer(id) {
      getDetail({
        id: id,
      }).then((data) => {
        this.manageOptionForm = data.data;
        this.priceData = data.data.materials;
        this.manageOptionForm.time = data.data.createTime;
        this.manageOptionForm.userName = data.data.createUserName;
        this.manageOptionForm.range = [
          data.data.appointmentStatusTime,
          data.data.appointmentEndTime,
        ];
        if (this.manageOptionForm.visitType)
          this.manageOptionForm.visitType = this.manageOptionForm.visitType + '';
        let formStatus = this.manageOptionForm.complaintParentStatus;
        //动态显示from表单
        this.formStatusHandler();
        this.manageOption[0].label = '登记  工单编号：' + this.manageOptionForm.wordId;
        this.drawerFlag = true;
        this.initSelectList();
        this.fixSignaturePicShow();
        this.changeUploader(formStatus, this.activeName);
      });
    },
    setFormItemDisabled(value){
      if (value.prop.indexOf('accessoriesStr') !== -1) {
      } else {
        value.disabled = true;
      }
    },
    //动态显示from表单
    formStatusHandler(){
        switch (this.manageOptionForm.complaintParentStatus) {
          case 1:
            const add = JSON.parse(JSON.stringify(this.repairAddOption));
            if (this.activeName === 'first') {
              this.areaFlag = true;
              this.propertyFlag = true;
              this.repairTypeFlag = true;
              add.column.forEach((value, index, array) => {
                
                this.setFormItemDisabled(value);
              });
            }
            this.manageOption = [add];
            break;
          case 2:
            //使用不同的变量并且使用深克隆避免各个option之间出现双向绑定
            const option = JSON.parse(JSON.stringify(this.repairAddOption));
            option.column.forEach((value, index, array) => {
              if (this.activeName !== 'first') {
                if (
                  value.prop !== 'isExigency' &&
                  value.prop !== 'appUser' &&
                  value.prop !== 'range' &&
                  value.prop !== 'remark1' &&
                  value.prop !== 'accessoriesStr1or2' &&
                  value.prop !== 'address'
                ) {
                  value.disabled = true;
                }
              } else {
                
                this.setFormItemDisabled(value);
              }
            });
            this.areaFlag = true;
            this.propertyFlag = true;
            this.repairTypeFlag = true;
            this.manageOption = [option];
            break;
          case 3:
            const addOption = JSON.parse(JSON.stringify(this.repairAddOption));
            addOption.column.forEach((value, index, array) => {
                this.setFormItemDisabled(value);
            });
            this.areaFlag = true;
            this.propertyFlag = true;
            this.repairTypeFlag = true;
            if (this.totalAmount > 0) {
              this.processDeptFlag = true;
            }
            this.manageOptionForm.processInputPeople = this.userInfo.nick_name;
            this.manageOption = [addOption];
            if (this.activeName !== 'first') {
              addOption.collapse = false;
              this.manageOption.push(this.repairManageOption);
            }
            break;
          case 4:
            const addOption1 = JSON.parse(JSON.stringify(this.repairAddOption));
            addOption1.column.forEach((value, index, array) => {
                this.setFormItemDisabled(value);
            });
            const manageOption = JSON.parse(JSON.stringify(this.repairManageOption));
            manageOption.column.forEach((value, index, array) => {
                this.setFormItemDisabled(value);
            });
            this.areaFlag = true;
            this.propertyFlag = true;
            this.repairTypeFlag = true;
            this.processDeptFlag = true;
            this.manageOptionForm.visitPeople = this.userInfo.nick_name;
            this.manageOption = [addOption1, manageOption];
            if (this.activeName !== 'first') {
              addOption1.collapse = false;
              manageOption.collapse = false;
              this.manageOption.push(this.repairVisitOption);
              if (this.manageOptionForm.isVisit === 0) {
                this.handlerHide(0);
              } else if (this.manageOptionForm.isVisit === 1) {
                this.handlerHide(1);
              } else {
                this.manageOptionForm.isVisit = 1;
                this.handlerHide(1);
              }
            }
            break;
          case 5:
            const addOption2 = JSON.parse(JSON.stringify(this.repairAddOption));
            addOption2.column.forEach((value, index, array) => {
                this.setFormItemDisabled(value);
            });
            const manageOption1 = JSON.parse(JSON.stringify(this.repairManageOption));
            manageOption1.column.forEach((value, index, array) => {
                this.setFormItemDisabled(value);
            });
            const visitOption = JSON.parse(JSON.stringify(this.repairVisitOption));
            visitOption.column.forEach((value, index, array) => {
               this.setFormItemDisabled(value);
            });
            this.areaFlag = true;
            this.propertyFlag = true;
            this.repairTypeFlag = true;
            this.processDeptFlag = true;
            this.visitTypeFlag = true;
            this.manageOption = [addOption2, manageOption1, visitOption];
            this.handlerHide(this.manageOptionForm.isVisit);
            break;
        }
    },
    // 修复签名图片不显示的问题
    fixSignaturePicShow() {
      setTimeout(() => {
        let _el = document.querySelector(
          'div[id*="el-collapse-content"] > div > div > div:nth-child(13) > div > div > div > div.avue-upload.avue-upload--list.avue-upload--upload > div.el-upload.el-upload--picture-img'
        );
        if (_el) {
          _el.style.display = 'inline-block';
          _el.addEventListener('click', (e) => {
            setTimeout(() => {
              _el.querySelector('div>div>span>i').style.color = '#fff';
            });
          });
        }
      });
    },
    //办理弹窗保存
    manageSave(form, done) {
      this.manageSubmit = true;
      this.manageOptionForm.materials = this.priceData;
      this.manageOptionForm.totalAmount = this.totalAmount;
      let b = '';
      if (this.manageOptionForm.accessoriesStr1or2 instanceof Array) {
        this.manageOptionForm.accessoriesStr1or2.forEach((value, index, array) => {
          if (index == this.manageOptionForm.accessoriesStr1or2.length - 1) {
            b += value.value;
          } else {
            b += value.value + ',';
          }
        });
        this.manageOptionForm.accessoriesStr1or2 = b;
      } else if (typeof this.manageOptionForm.accessoriesStr1or2 == 'string') {
      } else {
        this.manageOptionForm.accessoriesStr1or2 = b;
      }
      form = this.manageOptionForm;
      this.$refs.manageOptionFormRef.validate((valid) => {
        if (valid) {
          if (form.range) {
            form.appointmentStatusTime = form.range[0];
            form.appointmentEndTime = form.range[1];
          }
          update1(form).then(
            () => {
              this.manageSubmit = false;
              this.drawerFlag = false;
              this.onLoad2();
              this.$message.success('操作成功!');
              this.$refs.manageOptionFormRef.resetForm();
            },
            (error) => {
              console.log(error);
              this.manageSubmit = false;
            }
          );
        }
        this.manageSubmit = false;
      });
    },
    //办理弹窗提交
    manageCommit() {
      this.manageSubmit = true;
      this.manageOptionForm.materials = this.priceData;
      if (this.manageOptionForm.complaintParentStatus == 4) {
        this.commit();
      } else {
        this.$refs.manageOptionFormRef.validate((valid) => {
          if (valid) {
            this.manageOperatorDept = this.manageOptionForm.manageOperatorDept;
            this.commitFlag = true;
            this.manageSubmit = false;
          } else {
            this.manageSubmit = false;
          }
        });
      }
    },
    commit(form) {
      this.manageSubmit = true;
      this.manageOptionForm.totalAmount = this.totalAmount;
      if (this.manageOptionForm.complaintParentStatus != 4) {
        if (!this.manageOperatorDept) {
          this.$message.error('请选择提交部门!');
          this.manageSubmit = false;
          return;
        }
      }
      let b = '';
      if (this.manageOptionForm.accessoriesStr1or2 instanceof Array) {
        this.manageOptionForm.accessoriesStr1or2.forEach((value, index, array) => {
          if (index == this.manageOptionForm.accessoriesStr1or2.length - 1) {
            b += value.value;
          } else {
            b += value.value + ',';
          }
        });
        this.manageOptionForm.accessoriesStr1or2 = b;
      } else if (typeof this.manageOptionForm.accessoriesStr1or2 == 'string') {
      } else this.manageOptionForm.accessoriesStr1or2 = b;

      //首先清空查询过来的部门和经办人
      this.manageOptionForm.operatorDept = '';
      this.manageOptionForm.operatorId = '';

      form = this.manageOptionForm;
      //将提交时选择的部门和经办人赋值给form，当保存或者不选择经办人时，这里的经办人就是空
      form.operatorDept = this.manageOperatorDept;
      this.getOperatorDeptName(this.manageOperatorDept);
      form.operatorDeptName = this.operatorDeptName;
      form.operatorId = this.operatorId;
      this.getOperatorName(this.operatorId);
      form.operatorName = this.operatorName;
      this.$refs.manageOptionFormRef.validate((valid) => {
        if (valid) {
          if (form.range) {
            form.appointmentStatusTime = form.range[0];
            form.appointmentEndTime = form.range[1];
          }
          update2(form).then(
            () => {
              this.manageSubmit = false;
              this.commitFlag = false;
              this.drawerFlag = false;
              this.onLoad2();
              this.$message.success('操作成功!');
              this.manageOperatorDept = '';
              this.operatorId = '';
              this.$refs.manageOptionFormRef.resetForm();
            },
            (error) => {
              console.log(error);
              this.manageSubmit = false;
            }
          );
        }
        this.manageSubmit = false;
      });
    },
    handleClick(tab, event) {
      if (tab.name === 'first') {
        this.query1 = {
          isNull: 0, //初始化加载无经办人工单
        };
        this.onLoad1();
      }
      if (tab.name === 'second') {
        this.query2 = {};
        this.onLoad2();
      }
      if (tab.name === 'third') {
        this.query3 = {
          complaintParentStatus: 5,
        };
        this.onLoad3();
      }
    },
    //行选中
    handleRowClick(row) {
      this.$refs.crud.toggleSelection();
      this.$refs.crud.toggleRowSelection(row);
    },
    handleDrawerClose(hide) {
      this.repairAddOption.label = '登记';
      this.manageOption = [];
      this.manageOptionForm = {};
      this.priceData = [];
      this.areaFlag = false;
      this.propertyFlag = false;
      this.repairTypeFlag = false;
      this.processDeptFlag = false;
      this.visitTypeFlag = false;
      this.readOnly = false;

      hide();
    },
    initSelectList() {
      getCommunity({}).then((data) => {
        this.allPropertyList = data.data;
      });
      getOptionNode({}).then((data) => {
        this.allPowerPropertyList = data.data;
      });
      getDictionary('complaint_status').then((data) => {
        this.allComplaintStatusList = data.data;
      });
      getDictionary('complaint_visit_type').then((data) => {
        this.allVisitTypeList = data.data;
      });
      selectDept().then((data) => {
        this.allDeptList = data.data;
      });
      selectType().then((data) => {
        this.allPowerTypeList = data.data;
      });
      selectAllType().then((data) => {
        this.allTypeList = data.data;
      });
    },
    changeSelectType(value) {
      this.repairAddFrom.repairTypeId = '';
      this.manageOptionForm.repairTypeId = '';
      this.allPowerTypeList = [];
      selectType({ id: value }).then((data) => {
        this.allPowerTypeList = data.data;
      });
    },
    changeSelectUser(value) {
      this.operatorId = '';
      this.designateFrom.operatorId = '';
      this.allUserList = [];
      selectUser(value).then((data) => {
        this.allUserList = data.data;
      });
    },
    //新增弹窗相关
    openAddDialog() {
      this.repairAddFrom.time = new Date();
      this.repairAddFrom.userName = this.userInfo.nick_name;
      this.repairAddShowDialogFlag = true;
    },
    quitRepairAddDialog() {
      this.repairAddShowDialogFlag = false;
      this.propertyFlag = false;
      this.repairAddFrom = {};
      this.$refs.repairAddFormRef.resetFields();
    },
    repairAddCommit() {
      this.$refs.repairAddFormRef.validate((valid) => {
        if (valid) {
          this.repairAddFrom.complaintParentStatus = 2;
          this.addCommitFlag = true;
        }
      });
    },
    repairAddSubmit(form, done) {
      //保存时done不为null，提交时点击确定时done为null
      if (!done) {
        if (!this.operatorDept) {
          this.$message.error('请选择提交部门!');
          return;
        }
        //提交弹窗确认按钮
        this.addSubmit = true;
      }

      //校验附件格式拼接成字符串
      let a = '';
      if (this.repairAddFrom.accessoriesStr1or2 instanceof Array) {
        this.repairAddFrom.accessoriesStr1or2.forEach((value, index, array) => {
          if (index == this.repairAddFrom.accessoriesStr1or2.length - 1) {
            a += value.value;
          } else {
            a += value.value + ',';
          }
        });
        this.repairAddFrom.accessoriesStr1or2 = a;
      } else if (typeof this.repairAddFrom.accessoriesStr1or2 == 'string') {
      } else {
        this.repairAddFrom.accessoriesStr1or2 = a;
      }
      form = this.repairAddFrom;
      form.operatorDept = this.operatorDept;
      this.getOperatorDeptName(this.operatorDept);
      form.operatorDeptName = this.operatorDeptName;
      form.operatorId = this.operatorId;
      this.getOperatorName(this.operatorId);
      form.operatorName = this.operatorName;
      this.$refs.repairAddFormRef.validate((valid) => {
        if (valid) {
          if (form.range) {
            form.appointmentStatusTime = form.range[0];
            form.appointmentEndTime = form.range[1];
          }
          add(form).then(
            () => {
              this.repairAddShowDialogFlag = false;
              this.addCommitFlag = false;
              this.addSubmit = false;
              this.onLoad1();
              this.onLoad2();
              this.$message.success('操作成功!');
              this.operatorDept = '';
              this.operatorId = '';
              this.$refs.repairAddFormRef.resetFields();
              if (done) {
                setTimeout(() => {
                  done();
                }, 2000);
              }
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },

    //历程弹窗
    openRepairLogDialog(id, title) {
      if (id === 1) {
        id = this.manageOptionForm.id;
        title = this.manageOptionForm.wordId;
      }
      this.$refs.repairLog.openRepairLogDialog(id, title);
    },

    //选择收费项弹窗
    openRepairCostPriceDialog() {
      this.$refs.repairCostPrice.openRepairCostPriceDialog(this.priceData);
    },

    //回退弹窗
    openRollBackDialog(row) {
      if (row == 1) {
        row = this.manageOptionForm;
      }
      this.repairRollBackFrom.id = row.id;
      this.allComplaintStatusListCopy = this.allComplaintStatusList.filter(function (item) {
        return item.dictKey < row.complaintParentStatus;
      });
      this.repairRollBackFlag = true;
    },
    closeRollBackDialog() {
      this.allComplaintStatusListCopy = [];
      this.repairRollBackFrom = {};
      this.repairRollBackFlag = false;
    },
    repairRollBack() {
      this.$refs.rollBackFromRef.validate((valid) => {
        if (valid) {
          this.repairRollBackFlag = false;
          repairRollBack(this.repairRollBackFrom).then(
            () => {
              this.onLoad2();
              this.drawerFlag = false;
              this.$message.success('操作成功!');
              this.allComplaintStatusListCopy = [];
              this.repairRollBackFrom = {};
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
        }
      });
    },
    showResult(row) {
      if (row.complaintParentStatus == 1) {
        return '登记中';
      } else if (row.complaintParentStatus == 2) {
        return '受理中';
      } else if (row.complaintParentStatus == 3) {
        if (row.processResult == 2) {
          return '处理完成';
        }
        return '处理中';
      } else if (row.complaintParentStatus == 4) {
        if (row.visitResult) {
          return '核验完成';
        }
        return '核验中';
      } else if (row.complaintParentStatus == 5) {
        return '已完成';
      }
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({
            ids: row.id,
          });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    repairClose() {
      const id = this.manageOptionForm.id;
      this.$prompt('关闭原因：', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        inputType: 'textarea',
      })
        .then(({ value }) => {
          return close({
            id: id,
            repairLogRemark: value,
          });
        })
        .then(() => {
          this.drawerFlag = false;
          this.onLoad2();
          this.$message.success('操作成功!');
        })
        .catch(() => {});
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({
            ids: this.ids,
          });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({
          id: this.form.id,
        }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset1() {
      this.query1 = {
        isNull: 0, //初始化加载无经办人工单
      };
      this.onLoad1();
    },
    searchReset2() {
      this.query2 = {};
      this.onLoad2();
    },
    searchReset3() {
      this.query3 = {};
      this.onLoad3();
    },
    searchChange1(params, done) {
      this.query1 = params;
      this.page1.currentPage = 1;
      this.onLoad1();
    },
    searchChange2(params, done) {
      this.query2 = params;
      this.page2.currentPage = 1;
      this.onLoad3();
    },
    searchChange3(params, done) {
      this.query3 = params;
      this.page3.currentPage = 1;
      this.onLoad3();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange1(currentPage) {
      this.page1.currentPage = currentPage;
    },
    currentChange2(currentPage) {
      this.page2.currentPage = currentPage;
    },
    currentChange3(currentPage) {
      this.page3.currentPage = currentPage;
    },
    sizeChange1(pageSize) {
      this.page1.pageSize = pageSize;
    },
    sizeChange2(pageSize) {
      this.page2.pageSize = pageSize;
    },
    sizeChange3(pageSize) {
      this.page3.pageSize = pageSize;
    },
    onLoad1(page) {
      page = page || this.page1;
      this.loading1 = true;
      poolPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
          },
          this.query1
        )
      ).then(({ data }) => {
        this.page1.total = data.total;
        this.data1 = data.records;
        this.loading1 = false;
        this.selectionClear();
      });
    },
    onLoad2(page) {
      page = page || this.page2;
      this.loading2 = true;
      getList(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
          },
          this.query2
        )
      ).then(({ data }) => {
        this.page2.total = data.total;
        this.data2 = data.records;
        this.loading2 = false;
        this.selectionClear();
      });
    },
    onLoad3(page) {
      page = page || this.page3;
      this.loading3 = true;
      getList(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
          },
          this.query3
        )
      ).then(({ data }) => {
        this.page3.total = data.total;
        this.data3 = data.records;
        this.loading3 = false;
        this.selectionClear();
      });
    },
    handleClose() {
      this.repairManageFrom = {};
    },
  },
};
</script>

<style scoped>
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
/deep/ .avue-form__menu {
  height: 200px;
}
/deep/ .el-input.is-disabled .el-input__inner {
  color: black;
}
</style>
<style scoped>
.avue-crud__pagination {
  height: 25px;
}
</style>
